"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledBaseComponents = require("styled-base-components");

var _styledConfig = require("styled-config");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  width: ", ";\n  margin-right: auto;\n  margin-left: auto;\n  font-size:  ", ";\n  font-weight: ", ";\n  line-height: 1.5;\n  box-sizing: border-box;\n  @media (min-width: ", ") {\n    max-width: ", ";\n    box-sizing: border-box;\n  };\n  @media (min-width: ", ") {\n    max-width: ", ";\n  };\n  @media (min-width: ", ") {\n    max-width: ", ";\n  };\n  @media (min-width: ", ") {\n    max-width: ", ";\n  };\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = (0, _styledComponents.default)(_styledBaseComponents.Div)(_templateObject(), function (props) {
  return (0, _styledConfig.getFontFamily)(props, 'container', 'default');
}, function (props) {
  return (0, _styledConfig.getWidth)(props, 'container', 'default');
}, function (props) {
  return (0, _styledConfig.getFontSize)(props, 'container', 'default');
}, function (props) {
  return (0, _styledConfig.getFontWeight)(props, 'container', 'default');
}, function (props) {
  var screenWidth = (0, _styledConfig.getBreakpointSize)(_objectSpread({}, props, {
    sm: true
  }));
  return screenWidth;
}, function (props) {
  return props.fluid ? (0, _styledConfig.getWidth)(props, 'container', 'default') : (0, _styledConfig.getWidth)(props, 'container', 'fluid', 'sm');
}, function (props) {
  var screenWidth = (0, _styledConfig.getBreakpointSize)(_objectSpread({}, props, {
    md: true
  }));
  return screenWidth;
}, function (props) {
  return props.fluid ? (0, _styledConfig.getWidth)(props, 'container', 'default') : (0, _styledConfig.getWidth)(props, 'container', 'fluid', 'md');
}, function (props) {
  var screenWidth = (0, _styledConfig.getBreakpointSize)(_objectSpread({}, props, {
    lg: true
  }));
  return screenWidth;
}, function (props) {
  return props.fluid ? (0, _styledConfig.getWidth)(props, 'container', 'default') : (0, _styledConfig.getWidth)(props, 'container', 'fluid', 'lg');
}, function (props) {
  var screenWidth = (0, _styledConfig.getBreakpointSize)(_objectSpread({}, props, {
    xl: true
  }));
  return screenWidth;
}, function (props) {
  return props.fluid ? (0, _styledConfig.getWidth)(props, 'container', 'default') : (0, _styledConfig.getWidth)(props, 'container', 'fluid', 'xl');
});
exports.Container = Container;
Container.defaultProps = {
  theme: _styledConfig.theme
};